import EditableTextInput from '../../components/common/TextInputs/EditableTextInput';
import { useCommonStore } from '../../stores/commonStore';
import { useRequestorStore } from '../../stores/requestorStore';
import {
    getRequest,
    updateRequest,
    getProductsforAllFSNs,
    createRequest,
    getProductsPriorities,
    assignRequestToVendor,
    getProductsforRequest,
    acceptRequestComplexities,
    updateAssigneeStatus
} from '../../utils/api/requestApi';
import { IProduct, IProductSize, ProductImage } from '../../types/product';
import { IRequestInfo, IReqAssigneeItem } from '../../types/requester';
import { useHistory, useParams, useLocation, Link } from 'react-router-dom';
import IconButton from '../../components/common/Buttons/IconButton';
import StatusButton from '../../components/common/Buttons/StatusButton';
import ButtonFilledSmall from '../../components/common/Buttons/ButtonFilledSmall';
import ButtonBorderedSmall from '../../components/common/Buttons/ButtonBorderedSmall';
import TableHeaderCell from '../../components/common/Table/TableHeaderCell';
import TablePlainDataCell from '../../components/common/Table/TablePlainDataCell';
import TableTextCell from '../../components/common/Table/TableTextCell';
import { useEffect, useState } from 'react';
import { useVendorStore } from '../../stores/vendorStore';
import { UserInfo } from '../../types/auth';
import { useAuthStore } from '../../stores/authStore';
import { ProductStatus, Roles, Screens, RequestStages } from '../../utils/enums';
import ButtonFilled from '../../components/common/Buttons/ButtonFilled';
import { Routes } from '../../utils/constants/routes';
import { COMPLEXITIES, STATUSES } from '../../utils/constants';
interface QueryParams {
    id: string;
}
interface ILocationState {
    assigneeInfo?: any;
}
const RequestBreakDown = () => {
    const setFlyoutRightOpen = useCommonStore((state) => state.setFlyoutRightOpen);
    const setLoading = useCommonStore((state) => state.setLoading);
    const loading = useCommonStore((state) => state.loading);
    const fsns = useRequestorStore((state) => state.fsns);
    const setFsns = useRequestorStore((state) => state.setFsns);
    const products: IProduct[] = useRequestorStore((state) => state.products);
    const setProducts = useRequestorStore((state) => state.setProducts);
    const setActiveProduct = useRequestorStore((state) => state.setActiveProduct);
    const setShowComments = useVendorStore((state) => state.setShowComments);
    const setShowFsnDetails = useVendorStore((state) => state.setShowFsnDetails);
    const setShowActiveRequest = useRequestorStore((state) => state.setShowActiveRequest);
    const setShowActiveProduct = useRequestorStore((state) => state.setShowActiveProduct);
    const user: UserInfo = useAuthStore((state) => state.user);
    const activeRole = useAuthStore((state) => state.activeRole);
    const history = useHistory();
    const [complexity, setComplexity] = useState({});
    const [currentRequest, setCurrentRequest] = useState<IRequestInfo | null>(null);

    const { id } = useParams<QueryParams>();

    const headerData = ['', 'FSN', 'Type', 'Vertical', 'Dimensions', 'Complexity', '', ''];
    const showProceedBtn =
        ([Roles.REQUESTOR, Roles.OPS_MANAGER].includes(user?.roles[0]?.name) && currentRequest?.stage === RequestStages.CREATION) ||
        [Roles.THREED_AGENCY, Roles.THREED_ARTIST, Roles.THREED_ARTIST_OR_AGENCY].includes(user?.roles[0]?.name);

    const isAcceptedVendor = currentRequest?.assignee?.some((a) => a?.user?.id === user?.id && a?.status === STATUSES.ACCEPTED);

    const handleComments = (index: number) => {
        setActiveProduct(products[index]);
        setShowActiveRequest(false);
        setShowActiveProduct(true);
        if (true) {
            setFlyoutRightOpen(true);
            setShowComments(true);
            setShowFsnDetails(false);
        }
    };

    const handleFsnDetails = (index: number) => {
        setActiveProduct(products[index]);
        setShowActiveRequest(false);
        setShowActiveProduct(true);
        if (true) {
            setFlyoutRightOpen(true);
            setShowComments(false);
            setShowFsnDetails(true);
        }
    };
    const { state: LocationState } = useLocation<ILocationState>();

    const getProducts = async () => {
        try {
            setLoading(true);
            if (id) {
                const response = await getRequest(id);
                const sortedProducts = response.data.products.sort((a, b) => parseFloat(a.priority) - parseFloat(b.priority));
                const productFsns = sortedProducts.map((product: IProduct) => product.fsn);
                setFsns(productFsns);
                const responseFromZulu = await getProductsforRequest(id);
                const productStatuses: String[] = [];
                const requiredProductData: IProduct[] = [];
                for (let i = 0; i < responseFromZulu.data.productCards.length; i++) {
                    const newObject = {
                        ...responseFromZulu.data.productCards[i],
                        medias: sortedProducts[i].medias,
                        modelStatus: sortedProducts[i].status,
                        complexity: sortedProducts[i].complexity
                    };
                    requiredProductData.push(newObject);
                    productStatuses.push(sortedProducts[i].status);
                }
                setCurrentRequest(response.data);
                setProducts(requiredProductData);
            }
        } catch (error) {
            console.log('error', error);
        }
        setLoading(false);
    };

    useEffect(() => {
        getProducts();
        return () => {
            setProducts([]);
        };
    }, []);

    const handlePrimaryAction = async (id: string, complexity) => {
        if (user.roles.length) {
            const userRole = activeRole;
            if (userRole === Roles.THREED_ARTIST && !isAcceptedVendor) {
                await acceptRequestComplexities(id, complexity);
                await updateAssigneeStatus({ requestId: id, status: STATUSES.ACCEPTED });
                history.goBack();
            } else {
                // routing to card list
                // setActiveRequest(id);
                let userRoute = '';
                if (userRole === Roles.REQUESTOR) {
                    userRoute = Routes.REQUESTER_ROUTES.PRODUCTS;
                } else if (userRole === Roles.OPS_MANAGER) {
                    userRoute = Routes.OPS_ROUTES.PRODUCTS;
                } else {
                    userRoute = Routes.VENDOR_ROUTES.PRODUCTS;
                }

                history.push(`${userRoute}/${id}`);
            }
        }
    };

    const handleComplexityChange = (e) => {
        const fsn_number = e.target.dataset.fsnnumber;
        const complexity_value = e.target.value;
        const newobject = {};
        newobject[fsn_number] = complexity_value;
        setComplexity((prevState) => {
            return { ...prevState, ...newobject };
        });
    };

    const getDimensions = (productSize) => {
        const widthval = productSize?.width?.value || '';
        const depthval = productSize?.depth?.value || '';
        const heightval = productSize?.height?.value || '';

        const units = productSize?.width?.qualifier || productSize?.depth?.qualifier || productSize?.depth?.qualifier || '';

        return `${widthval} x ${depthval} x ${heightval} ${units}`;
    };

    if (!loading && !(products?.length > 0)) return <div>No data found</div>;

    return (
        <div className="container mx-auto p-8 pb-0 h-full flex flex-col">
            <div className="pb-1">
                <div className="mb-3 sm:mb-0 w-full flex items-center justify-between py-4 body-bg-color sticky top-0">
                    <div className="">
                        <div className="flex items-center mb-2">
                            <div className="text-xl font-semibold text-black-600 mr-4 flex items-center">
                                All Requests
                                <svg className="ml-4" width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M0.380479 19.01C0.870479 19.5 1.66048 19.5 2.15048 19.01L10.4605 10.7C10.8505 10.31 10.8505 9.67999 10.4605 9.28999L2.15048 0.979988C1.66048 0.489988 0.870479 0.489988 0.380479 0.979988C-0.109521 1.46999 -0.109521 2.25999 0.380479 2.74999L7.62048 9.99999L0.370478 17.25C-0.109522 17.73 -0.109521 18.53 0.380479 19.01Z"
                                        fill="#AFAFAF"
                                    />
                                </svg>
                            </div>
                            <div className="text-black-600 text-xl overflow-ellipsis block font-semibold">Request-{id}</div>
                            {/* <EditableTextInput textColor="text-black-600" value={`Request-${id || 'draft'}`} placeholder="Request #ABC760" size={10} onTextChangeDone={(value) => console.log(value, 'TEXTTEXTTEXT')} /> */}
                        </div>
                        <div className="text-gray-500 whitespace-no-wrap text-base capitalize">You can flag any products’ information here, the default state is approved unless flagged</div>
                    </div>
                </div>
                <div className="-mx-4 sm:-mx-8 px-4 sm:px-8 py-4 overflow-x-auto">
                    <div className="inline-block min-w-full shadow-sm rounded-lg overflow-hidden">
                        <table className="min-w-full leading-normal table-auto">
                            {products?.length > 0 && (
                                <thead>
                                    <tr>
                                        {headerData?.map((title) => (
                                            <TableHeaderCell label={title} />
                                        ))}
                                    </tr>
                                </thead>
                            )}
                            <tbody>
                                {products.map(({ fsn, status, groupCode, stage, complexity, verticalName, previewImages, productImages, productSize }, index) => {
                                    return (
                                        <tr onChange={handleComplexityChange}>
                                            <TablePlainDataCell dataLabel={headerData[0]}>
                                                <>{productImages && <img src={productImages[0].url} alt="" className="w-10 h-10 object-contain" />}</>
                                            </TablePlainDataCell>
                                            {fsn && <TableTextCell dataLabel={headerData[1]} label={fsn} />}

                                            {/* type */}
                                            <TableTextCell dataLabel={headerData[2]} label={groupCode ? groupCode : ''} />

                                            {/* vertical */}
                                            {status && (
                                                <TablePlainDataCell dataLabel={headerData[3]}>
                                                    <div className="">
                                                        <p>{verticalName}</p>
                                                    </div>
                                                </TablePlainDataCell>
                                            )}

                                            {/* Dimensions */}
                                            <TableTextCell dataLabel={headerData[4]} label={getDimensions(productSize)} />

                                            <TablePlainDataCell dataLabel={headerData[5]}>
                                                {activeRole === Roles.THREED_ARTIST ? (
                                                    complexity ? (
                                                        <p>{complexity}</p>
                                                    ) : (
                                                        <select onChange={(e) => console.log('dropdown', e)} className="border px-4 py-2 complexity_dropdown rounded-sm" data-fsnnumber={fsn}>
                                                            <option>Select Complexity</option>
                                                            <option value={COMPLEXITIES.SIMPLE}>Simple</option>
                                                            <option value={COMPLEXITIES.MEDIUM}>Medium</option>
                                                            <option value={COMPLEXITIES.HARD}>Hard</option>
                                                        </select>
                                                    )
                                                ) : (
                                                    <p>{complexity ? complexity : ''}</p>
                                                )}
                                            </TablePlainDataCell>

                                            <TablePlainDataCell dataLabel={headerData[6]}>
                                                <div onClick={() => handleComments(index)} className=" cursor-pointer">
                                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M17.6464 15.5236L18.5 16.3771V15.17V2V1.5H18H2H1.5V2V14V14.5H2H16.6229L17.6464 15.5236ZM16.3536 15.6464L16.2071 15.5H16H2C1.17614 15.5 0.5 14.8239 0.5 14V2C0.5 1.17614 1.17614 0.5 2 0.5H18C18.8239 0.5 19.5 1.17614 19.5 2V18.7929L16.3536 15.6464Z"
                                                            fill="#323232"
                                                            stroke="#111827"
                                                        />
                                                    </svg>
                                                </div>
                                            </TablePlainDataCell>
                                            <TablePlainDataCell dataLabel={headerData[7]}>
                                                <div onClick={() => handleFsnDetails(index)} className="cursor-pointer">
                                                    <svg width="16" height="4" viewBox="0 0 16 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M2 0C0.9 0 0 0.9 0 2C0 3.1 0.9 4 2 4C3.1 4 4 3.1 4 2C4 0.9 3.1 0 2 0ZM14 0C12.9 0 12 0.9 12 2C12 3.1 12.9 4 14 4C15.1 4 16 3.1 16 2C16 0.9 15.1 0 14 0ZM8 0C6.9 0 6 0.9 6 2C6 3.1 6.9 4 8 4C9.1 4 10 3.1 10 2C10 0.9 9.1 0 8 0Z"
                                                            fill="#323232"
                                                        />
                                                    </svg>
                                                </div>
                                            </TablePlainDataCell>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            {/* bottom bar */}
            <div className="sticky bottom-0 bg-white p-4 shadow-sm mt-auto">
                <div className="container flex justify-between">
                    <div className="">
                        <h1 className="text-gray-500 whitespace-no-wrap text-sm uppercase">current Status</h1>
                        <div className="text-gray-900 whitespace-no-wrap text-lg uppercase">{currentRequest && STATUSES[currentRequest.status]}</div>
                    </div>
                    <div className="flex justify-end gap-4 w-1/3">
                        {showProceedBtn && (
                            <ButtonFilled
                                fullWidth
                                label={activeRole === Roles.THREED_ARTIST && !isAcceptedVendor ? 'Accept Request' : 'Proceed'}
                                onClick={() => {
                                    handlePrimaryAction(id, complexity);
                                }}
                            ></ButtonFilled>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RequestBreakDown;
